import apiClient from "./apiClient";

/**
 * Fetch list of proposal records
 */
export const getProposals = async (companyCode, options = {}) => {
  try {
    const params = { companyCode };
    if (options.clientId) params.clientId = options.clientId;
    if (options.leadId) params.leadId = options.leadId;
    if (options.companyName) params.companyName = options.companyName;
    if (options.employeeId) params.employeeId = options.employeeId;
    if (options.search) params.search = options.search;
    if (options.dateFrom) params.dateFrom = options.dateFrom;
    if (options.dateTo) params.dateTo = options.dateTo;
    if (options.page) params.page = options.page;
    if (options.pageSize) params.pageSize = options.pageSize;

    const data = await apiClient.get("/api/proposal-records", {
      params,
      signal: options.signal,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });

    const proposals = data?.proposals || data?.items || data?.data || (Array.isArray(data) ? data : []);

    return {
      success: true,
      proposals,
      total: data?.total || proposals.length,
    };
  } catch (error) {
    if (error?.name === "CanceledError" || error?.name === "AbortError" || error?.code === "ERR_CANCELED") {
      throw error;
    }
    console.error("[ProposalService] getProposals error:", error);
    return {
      success: false,
      proposals: [],
      total: 0,
    };
  }
};

/**
 * Create a new proposal record
 */
export const createProposal = async (companyCode, payload) => {
  try {
    const data = await apiClient.post(
      "/api/proposal-records",
      { ...payload, companyCode },
      { headers: companyCode ? { "x-active-company-code": companyCode } : {} }
    );
    return data;
  } catch (error) {
    console.error("[ProposalService] createProposal error:", error);
    return { success: false, message: error.message };
  }
};

/**
 * Fetch high-performance aggregated proposal summary & company list
 */
export const getProposalSummary = async (companyCode, options = {}) => {
  try {
    const params = { companyCode };
    if (options.employeeId) params.employeeId = options.employeeId;
    const data = await apiClient.get("/api/proposal-records/summary", {
      params,
      signal: options.signal,
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return data;
  } catch (error) {
    if (error?.name === "CanceledError" || error?.name === "AbortError" || error?.code === "ERR_CANCELED") {
      throw error;
    }
    console.error("[ProposalService] getProposalSummary error:", error);
    return { success: false, totalProposals: 0, engagedAccounts: 0, companies: [] };
  }
};
